import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/facultyMembers`;

// * Route configuration object for facultyMembers-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const facultyMembersRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:facultyMemberId`,
  edit: `${baseRoute}/edit/:facultyMemberId`,
} as const;

// ! these are breadcrumbs translation not page title
export const facultyMembersRouteTranslation: IRouteTranslation<
  typeof facultyMembersRoutesObj
> = {
  list: "facultyMembersList",
  create: "addFacultyMember",
  edit: "editFacultyMember",
  view: "viewFacultyMember",
};

// * Extracts the route parameters for the facultyMembers route configuration.
export type IFacultyMembersRouteParams = IExtractRouteParamMap<
  typeof facultyMembersRoutesObj
>;

// * Path functions for the facultyMembers routes.
export const facultyMembersPath = createPaths<
  typeof facultyMembersRoutesObj,
  IFacultyMembersRouteParams
>(facultyMembersRoutesObj);

// * Breadcrumbs {translation and route} for the faculty member routes
export const facultyMembersBreadcrumbs = createBreadcrumbObject<
  typeof facultyMembersRoutesObj
>(facultyMembersRoutesObj, facultyMembersRouteTranslation);
rebase(facultyMembersBreadcrumbs, "list");
